module.exports = __webpack_public_path__ + "static/media/locationMap.4187a5b9.svg";